import React from 'react';
import { Trophy } from 'lucide-react';

interface HeaderProps {
    showNavbar: boolean;
    isLoaded: boolean;
}

const Header: React.FC<HeaderProps> = ({
    showNavbar,
    isLoaded,
}) => (
    <header
        className={`fixed inset-x-0 top-2 z-20
      bg-slate-900/80 backdrop-blur-xl border-b border-white/10
      w-11/12 max-w-full md:max-w-7xl px-0 md:px-6 py-2 md:py-4
      mx-auto rounded-2xl md:rounded-3xl
      transition-transform duration-300
      ${showNavbar ? 'translate-y-0' : '-translate-y-full'}`}
    >
        <div className="w-full max-w-full mx-auto">
            <div
                className={`flex items-center justify-between transition-all duration-1000 ${isLoaded
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 -translate-y-10'
                    }`}
            >
                <div className="flex items-center space-x-2 sm:space-x-3">
                    <div className="relative group w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16">
                        <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full blur opacity-75 group-hover:opacity-100 transition" />
                        <div className="relative w-full h-full bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                            <Trophy className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 text-slate-900" />
                        </div>
                    </div>
                    <div>
                        <h1 className="font-bold bg-gradient-to-r from-white to-yellow-400 bg-clip-text text-transparent text-xl sm:text-2xl md:text-3xl">
                            FENERBAHÇE
                        </h1>
                        <p className="text-yellow-400 font-semibold text-xs sm:text-sm tracking-widest">
                            VİZYON 2035
                        </p>
                    </div>
                </div>
                <div className="hidden md:flex items-center space-x-6 text-right">
                    <div>
                        <p className="text-slate-300 text-sm">Geleceğin</p>
                        <p className="text-yellow-400 font-bold text-lg">
                            Şampiyonları
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </header>
);

export default Header; 